require('./checkout');
require('./schedule');

// create the module before importing the sub-resources, as they don't each
// make their own angular module because reasons
let module = angular.module('app.directives', [
  'app.directives.checkout',
  'app.directives.schedule',
]);

// The act of importing these actually registers them with the angular module
// from above, so we're good to go at this point.
require('./analytics-geo-chart');
require('./authorize-account-form');
require('./boxcast-color-picker');
require('./boxcast-player');
require('./broadcast-basic-analytics');
require('./broadcast-card');
require('./broadcast-label-list');
require('./color-swatch');
require('./compare-to-percent');
require('./date-range');
require('./drag-resize');
require('./facebook-video.js');
require('./firmware-version');
require('./fixed-image-preview');
require('./low-latency-player');
require('./ng-onload');
require('./not-boxcast');
require('./number-spinner');
require('./overlay-image');
require('./radio-button-well');
require('./random-waiting-message');
require('./recording-source-chooser');
require('./recording-trimmer');
require('./scoreboard-diagnostics-status');
require('./scoreboard-link-status');
require('./show-password');
require('./source-chooser');
require('./star-rating');
require('./stat-block');
require('./stream-diagnostics');
require('./time-picker');
require('./upgrade-button');
require('./upload-modal-launcher');
require('./upload-slot');
require('./wifi-signal-strength');
require('./toggle-switch');

export default module;



// WEBPACK FOOTER //
// ./app/directives/_index.js